import i18n from "i18next";

export const formatValidationAlerts = (validHeadings, invalidHeadings) => {
  const alerts = [];
  if (validHeadings) {
    alerts.push({
      type: "success",
      title: i18n.t("importTool:import.alerts.validHeadings"),
      description: validHeadings,
    });
  }
  if (invalidHeadings) {
    alerts.push({
      type: "warning",
      title: i18n.t("importTool:import.alerts.ignoredHeadings"),
      description: invalidHeadings,
    });
  }
  return alerts;
};

export const formatInvalidHeadingsAlert = (error) => {
  return [
    {
      type: "error",
      title: i18n.t("importTool:import.alerts.invalidHeadings"),
      description: error,
    },
  ];
};

export const formatInsertSuccessAlert = (insertedCount) => {
  const description = i18n.t(`importTool:import.alerts.rowInserted`, {
    count: insertedCount,
  });

  return [
    {
      type: "success",
      title: i18n.t("importTool:import.alerts.successTitle"),
      description: description,
    },
  ];
};

export const formatUpdateSuccessAlert = (updatedCount, ignoredCount) => {
  const rowUpdated = i18n.t(`importTool:import.alerts.rowUpdated`, {
    count: updatedCount,
  });
  const rowIgnored = i18n.t(`importTool:import.alerts.rowIgnored`, {
    count: ignoredCount,
  });

  return [
    {
      type: "success",
      title: i18n.t("importTool:import.alerts.successTitle"),
      description: rowUpdated,
    },
    {
      type: "warning",
      description: rowIgnored,
    },
  ];
};

export const formatErrorsAlerts = (errors) => {
  const alerts = [];
  for (const [attribute, messages] of Object.entries(errors)) {
    alerts.push({
      type: "error",
      title: i18n.t("importTool:import.alerts.errorTitle", {
        count: messages.length,
        attribute,
      }),
      description: messages.join("\n"),
    });
  }
  return alerts;
};
